import { render, staticRenderFns } from "./PrimaryMenuColumn.vue?vue&type=template&id=ce1262ac&"
import script from "./PrimaryMenuColumn.vue?vue&type=script&lang=js&"
export * from "./PrimaryMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports